module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "tracking-ghg-cycles--cover.8b41e9ce.jpeg";